import * as React from 'react';
import './index.css';
import {Link, useParams} from "react-router-dom";
import {APP_LANDING, APP_LOGOUT_PATH, Client, EsignDocument, LegacyDocument, LegacyNote} from "../../types";
import {useEffect, useRef, useState} from "react";
import {
    getClient,
    getDocumentKey,
    getEsignDocument,
    getEsignProfiles, getFile,
    getLegacyDocument,
    getTemplates
} from "../../api";
import ExportPdfDocument from "../ExportPdfDocument";


const ExportClientFile: React.FunctionComponent = () => {
    const {clientId} = useParams();
    const [client, setClient] = useState<Client>();
    const [esignDocuments, setEsignDocuments] = useState<EsignDocument[]>([]);
    const [legacyDocuments, setLegacyDocuments] = useState<LegacyDocument[]>([]);
    const [legacyNotes, setLegacyNotes] = useState<LegacyNote[]>([]);
    const [imageUploads, setImageUploads] = useState<string[]>([])


    useEffect(() => {
        getClient(clientId)
            .then((c) => {
                setClient(c);
                setLegacyNotes(c.legacyNotes || []);

            });


    }, []);

    useEffect(() => {
        if (client !== undefined) {
            getEsignProfiles()
                .then((ps) => {
                    let profile = ps.filter((p) => p.name === "Promises12")[0];
                    client?.documents.forEach((d) => {
                        if (d.type.toLowerCase() === "upload") {


                            try {
                                getFile(d.url)
                                    .then((r) => {
                                        if (r.ok) {
                                            return r.blob();
                                        }
                                    })
                                    .then((blob) => new Promise(callback => {
                                        if (blob !== undefined) {
                                            let reader = new FileReader();
                                            reader.onload = function () {
                                                let dataUrl = this.result + "";
                                                if (d.url !== undefined && d.url.toLowerCase().endsWith(".pdf")) {
                                                    esignDocuments.push({
                                                        name: d.name,
                                                        fields: [],
                                                        status: d.status,
                                                        template: {
                                                            name: d.name,
                                                            url: dataUrl,
                                                            fields: []
                                                        }
                                                    });
                                                    setEsignDocuments([...esignDocuments]);
                                                } else {
                                                    imageUploads.push(dataUrl);
                                                    setImageUploads([...imageUploads]);
                                                }
                                            };
                                            reader.readAsDataURL(blob);
                                        }
                                    }))
                                    .catch((e) => console.error(e));

                            } catch (e) {

                            }

                        }
                        if (d.type.toLowerCase() === "form" || d.type.toLowerCase() === "note") {
                            const docValues = d.url.substring(d.url.indexOf("/s/")).split("/");
                            const esignDocumntId = docValues[3];
                            getDocumentKey(profile.uuid, esignDocumntId)
                                .then((k) => {
                                    getEsignDocument(esignDocumntId, profile.uuid, k.uuid)
                                        .then((ed) => {
                                            esignDocuments.push(ed);
                                            setEsignDocuments([...esignDocuments]);

                                        })
                                        .catch((e) => console.error(e))
                                })
                                .catch((e) => console.error(e));
                        }
                    })
                })
                .catch((e) => console.error(e))

            ///

            client.legacyDocuments.forEach((ld) => {
                getLegacyDocument(ld.id)
                    .then((ld) => {
                        legacyDocuments.push(ld);
                        setLegacyDocuments([...legacyDocuments])
                    })
                    .catch((e) => console.error(e));

            })
        }
    }, [client]);

    useEffect(() => {
        // console.log(esignDocuments)
    }, [esignDocuments])


    return ((client === undefined) ? <>...Loading...</> : <>
        <div className={"page export-file"} style={{width: '100%'}}>
            <h3>Client Information</h3>
            <h6>Full Name</h6>
            {client?.firstName + " " + client?.lastName}
            <h6>Client Id</h6>
            {client?.id}
            <h6>Balance</h6>
            {client?.balance}
            <h6>Absences</h6>
            {client?.absences}
            <h6>Total Hours Attended</h6>
            {client?.totalHoursAttended}
            <h6>Recommended Hours</h6>
            {client?.recommendedHours}
            <h6>Email</h6>
            {client?.email}
            <h6>Date of Birth</h6>
            {client?.dateofBirth}
            <h6>Date and Time of Assessment</h6>
            {client?.dateTimeofAssessment}
            <h6>Drivers License Number</h6>
            {client?.driverslicenseNumber}
            <h6>Drivers License State</h6>
            {client?.driverslicenseState}
            <h6>Social Security</h6>
            {client?.socialsecurityNumber}
            <h6>Telephone</h6>
            {client?.telephoneNumber}
            <h6>Address</h6>
            {client?.address?.addressLine1 + " " + client?.address.addressLine2 + " " + client?.address.city + " " + client?.address.state + " " + client?.address.zip}
            <h6>Email</h6>
            {client?.email}
            <h6>Client Diagnosis</h6>
            {client?.clientDiagnosis}
            <h6>Drug Test Due Date</h6>
            {client?.drugTestDueDate}
            <h6>Transactions</h6>
            <table>
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody>
                {client?.transactions.map((t) => (
                    <tr key={"t_" + t.uuid}>
                        <td>{t.createdAt}</td>
                        <td>{t.type}</td>
                        <td>{t.amount}</td>
                        <td>{t.description}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            <h6>Therapy Session Attendance</h6>
            <table>
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Attended</th>
                </tr>
                </thead>
                <tbody>
                {client?.attendances.map((a, index) => (
                    <tr key={"at_" + index}>
                        <td>{a.therapySession.date}</td>
                        <td>{a.attended ? "Yes" : "No"}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
        <div className="pagebreak"></div>
        {
            legacyNotes.map((note) => (
                <>
                    <p key={"ln_" + note.id} className={""}>
                        <h4>Note</h4>
                        <h5>Client Id</h5>
                        {note?.clientId}<br/>
                        <h5>Session Topic</h5>
                        {note?.sessionTopic}<br/>
                        <h5>Hours</h5>
                        {note?.hours}<br/>
                        <h5>Note</h5>
                        <pre style={{width: 500}}>{note?.note}</pre>
                        <br/>
                        <h5>Additional Note</h5>
                        <pre style={{width: 500}}>{note?.additionalNote}</pre>
                        <br/>
                        <h5>Session Date</h5>
                        {note?.sessionDate}<br/>
                        <h5>Session Time</h5>
                        {note?.sessionTime}<br/>
                        <h5>Session Notes</h5>
                        <pre style={{width: 500}}>{note?.sessionNotes}</pre>
                        <br/>
                        <h5>Session Progress</h5>
                        <pre style={{width: 500}}>{note?.sessionProgress}</pre>
                        <br/>
                        <h5>Session Activity</h5>
                        <pre style={{width: 500}}>{note?.sessionActivity}</pre>
                        <br/>
                        <h5>Session Contact</h5>
                        <pre style={{width: 500}}>{note?.sessionContact}</pre>
                        <br/>
                    </p>
                    <div className="pagebreak"></div>
                </>
            ))
        }

        {
            esignDocuments.map((d) => (
                <>
                    <ExportPdfDocument ed={d}/>
                </>
            ))
        }
        {
            legacyDocuments.map((ld) => (
                <div key={"ld_" + ld.id}>
                    {
                        ld?.pages.map((p) => (
                            <div key={"p_" + p.number}>
                                <div className={"document-wrapper"}
                                     style={{position: "relative", width: p.width, height: p.height}}>
                                    {
                                        p.fields.map((f) => (
                                            <div key={"f_" + f.id}
                                                 style={{
                                                     fontSize: 12,
                                                     position: "absolute",
                                                     top: f.y,
                                                     left: f.x
                                                 }}>{(f.value && f.value.startsWith("data:image")) ? <img src={f.value}/>: f.value}</div>
                                        ))
                                    }

                                    <img src={p.imageData} width={p.width} height={p.height}/>
                                </div>
                                <div className="pagebreak"></div>
                            </div>
                        ))
                    }
                </div>
            ))
        }
        {
            imageUploads.map((i) => (
                <>
                    <img alt={"upload"} src={i}/>
                    <div className="pagebreak"></div>
                </>
            ))
        }
    </>);
};

export default ExportClientFile;